import React, { useEffect, useState } from "react";
import "./FeatureProjects.css";
import { client } from "../../client";
import imageUrlBuilder from "@sanity/image-url";

/* ===== IMAGE BUILDER ===== */
const builder = imageUrlBuilder(client);
const urlFor = (source) =>
  source?.asset ? builder.image(source).width(1200).url() : "";

const FeaturedProjects = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    client
      .fetch(
        `*[_type == "featuredProject"] | order(order asc){
          _id,
          image,
          large,
          wide
        }`
      )
      .then(setProjects)
      .catch(console.error);
  }, []);

  return (
    <section className="featured">
      {/* Header */}
      <div className="featured-header">
        <h2>Featured Projects</h2>
        <a href="/projects" className="view-btn">
          View Projects
        </a>
      </div>

      {/* Grid */}
      <div className="featured-grid">
        {projects.map((p) => (
          <div
            key={p._id}
            className={`project-card 
              ${p.large ? "large" : ""} 
              ${p.wide ? "wide" : ""}`}
          >
            <div className="img-wrap">
              <img src={urlFor(p.image)} alt="project" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturedProjects;
